import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { OrderStatus } from '@patrianna-payments/shared-store/payments/types/openApiModels/OrderStatus'

import content from 'prismic-translates/transactions-history-page.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

const statusLabels: Partial<Record<OrderStatus, string>> = {
  [OrderStatus.PENDING]: t('pending'),
  [OrderStatus.SUCCESS]: t('completed'),
  [OrderStatus.FAILED]: t('failed'),
}

export default function TransactionStatus({ status = OrderStatus.SUCCESS }: { status?: OrderStatus }) {
  return (
    <span className={classes.status} data-testid='transaction-item-status'>
      {statusLabels[status] || statusLabels[OrderStatus.SUCCESS]}
    </span>
  )
}
